import { useAtom } from 'jotai';

import { ISelfResponse } from '@/shared/interfaces';
import { atom } from 'jotai/index';
import { QueryObserverResult } from '@tanstack/react-query';
import { fetchProfileQueryAtom } from '@/features/shared/model/fetchProfileQueryAtom';

type ProfileResponse = {
    profile: ISelfResponse | undefined;
    status: 'pending' | 'success' | 'error' | 'idle';
    refetch: () => Promise<
        QueryObserverResult<ISelfResponse | undefined, Error>
    >;
    errorMessage: string | null;
};

const profileFetchedAtom = atom(false);

export const useProfile = (): ProfileResponse => {
    const [{ refetch, error, data, status }] = useAtom(fetchProfileQueryAtom);
    const [isFetched, setIsFetched] = useAtom(profileFetchedAtom);

    return {
        profile: data,
        status: isFetched ? status : 'idle', // override this status to not have it set to 'pending' initially
        refetch: async () => {
            const refetchedData = await refetch();
            setIsFetched(true);
            return refetchedData;
        },
        errorMessage: error instanceof Error ? error.message : null,
    };
};
